// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2G_bg","name":"ConsentHeader_name__3vv1n","birthday":"ConsentHeader_birthday__3z_xP","skeleton":"ConsentHeader_skeleton__23dSN"};